/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import './loader.scss';
import './modifier/inline.scss';
import './modifier/inline-block.scss';
import './modifier/full.scss';
import './modifier/background.scss';
